/**
 * Posts question box component, gives usability for the input area of the question box.
 *
 */
export default function () {
    return {
        event: event,
        timeout: null,
        showTime: false,
        hiddenChecked: false,
        answerContent: '',
        answerFocus: false,
        resize() {
            if (!this.$refs.textArea) {
                return;
            }

            this.$nextTick(() => {
                this.$refs.textArea.style.height = '1px';
                this.$refs.textArea.style.height = this.$refs.textArea.scrollHeight + 'px';
            });
        },
        mouseOver: function () {
            this.showTime = true;
        },
        mouseLeave: function () {
            this.showTime = false;

            if (
                this.$refs.textArea &&
                this.$refs.textArea != document.activeElement &&
                this.hiddenChecked == false
            ) {
                this.answerFocus = false;
            }
        },
        mounted: function () {
            this.resize();
        },
    };
}
